
define ['./mypaymentsTable.scss'], () ->
  (RentappService, $state, $http, $compile, $cacheFactory, Landlord, RENTAPPLICATION_API_URL, Flash) ->
    restrict: "E"
    template: require("./mypaymentsTable.jade")
    link: (scope, element, attrs) ->
      Landlord.getMe().$promise.then (response) ->
        scope.landlord = response
      scope.is_loading = false

      scope.search_term = ""

      scope.pagination_options =
        limit: 25

      scope.$on('refresh-mypayments-table', (event, data) ->
        scope.load_table()
      )

      scope.format_transactions = (transactions) ->
        formatted = transactions.map((t) -> 
          if t.notes.toLowerCase().indexOf('withdrawal') != -1
            t.transaction_type = 'Withdrawal'
          else if t.notes.indexOf('Application fee') != -1
            t.transaction_type = 'Application Fee'
          else if t.notes.indexOf('Manual Fee') != -1
            t.transaction_type = 'Manual Fee'
          else if t.notes.toLowerCase().indexOf('refund') != -1
            t.transaction_type = 'Refund'
          else
            t.transaction_type = 'Other'
          
          if t.application
            t.application_id = t.application.split('/')[4]
          
          if t.status == 'success' or t.status == 'deposit'
            t.status_color = '#3EC19D'
            if t.status == 'success'
              t.status_label = 'Success'
            else
              t.status_label = 'Available'
          else if t.status == 'pending'
            t.status_color = '#757575'
            t.status_label = 'Pending'
          else
            t.status_color = '#DD485B'
            t.status_label = 'Failure'
          return t
        )
        return formatted
        

      scope.load_table = () ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        RentappService.getTransactions
          limit: 25
          offset: 0
        .then (response) ->
          scope.is_loading = false
          scope.total_count = response.data.meta.total_count
          scope.displayed = scope.format_transactions(response.data.objects)

      scope.search = (search_term) ->
        scope.is_loading = true
        $cacheFactory.get("$http").removeAll()

        RentappService.getTransactions
          limit: 25
          offset: 0
          search: search_term.trim()
        .then (response) ->
          scope.displayed = scope.format_transactions(response.data.objects)
          scope.is_loading = false
          scope.total_count = response.data.meta.total_count

      scope.$on('paginate', (event, data) ->
        scope.is_loading = true
        RentappService.getTransactions
          limit: 25
          offset: data.offset
          search: scope.search_term.trim()
        .then (response) ->
          scope.displayed = scope.format_transactions(response.data.objects)
          scope.is_loading = false
          scope.total_count = response.data.meta.total_count
        .finally ->
          scope.is_loading = false
      )

      scope.requestCsvReport = () ->
        $http.post "#{RENTAPPLICATION_API_URL}/api/v1/account/csv/"
        .then () ->
          Flash.create('success', "We are generating your csv, we email you when it's ready. You can navigate away from this page and we'll still notify you when it's complete", 2000, { id: 'transaction-table' }, true)
        .catch () ->
          Flash.create('danger', 'Failed to generate your csv. Please contact support at support@rentapplication.net')

      scope.load_table()



// WEBPACK FOOTER //
// ./directives/mypaymentsTable/mypaymentsTable.coffee